import axios from 'axios';

const BASE_URL = process.env.VUE_APP_APIURL;

const get = (headers) => (axios.get(`${BASE_URL}/api/Profiles`, headers)
    .then((r) => r.data)
    .catch((err) => console.log(err))
);

const getSettings = () => axios.get(`${BASE_URL}/api/Profiles/Settings`);
const getMySettings = () => axios.get(`${BASE_URL}/api/Profiles/My/Settings`);
const getMunicipalityTransferDocuments = () => axios.get(`${BASE_URL}/api/Profiles/MunicipalityTransferDocuments`);
const upsertMunicipalityTransferDocument = (data) => axios.put(`${BASE_URL}/api/Profiles/MunicipalityTransferDocuments`, data);
const deleteMunicipalityTransferDocument = (municipalityId) => axios.delete(`${BASE_URL}/api/Profiles/MunicipalityTransferDocuments/${municipalityId}`);
const getProfileAutomaticTransfer = () => axios.get(`${BASE_URL}/api/Profiles/AutomaticTransfer`);
const addProfileAutomaticTransfer = () => axios.post(`${BASE_URL}/api/Profiles/AutomaticTransfer`);
const deleteProfileAutomaticTransfer = () => axios.delete(`${BASE_URL}/api/Profiles/AutomaticTransfer`);
const addProfile = (data) => axios.post(`${BASE_URL}/api/Profiles`, data);
const update = (data, headers) => axios.put(`${BASE_URL}/api/Profiles`, data, headers);
const users = () => axios.get(`${BASE_URL}/api/Profiles/My/Users`);
const usersTask = () => axios.get(`${BASE_URL}/api/Profiles/My/UsersTask`);
const adminUsersTask = () => axios.get(`${BASE_URL}/api/Profiles/Admin/UsersTask`);
const all = (managedOnly) => axios.get(`${BASE_URL}/api/Profiles/All?managedOnly=${managedOnly}`);
// const allMapped = (managedOnly) => (axios.get(`${BASE_URL}/api/Profiles/All?managedOnly=${managedOnly}`)
//     .then((r) => {
//         const cache = r.data.map((i) => ({
//             Value: i.Id,
//             Text: i.Name,
//             IdNumber: i.IdNumber,
//             IsLeasingCompany: i.IsLeasingCompany,
//             ForbidTransfer: i.ForbidTransfer
//         }));
//         return cache;
//     })
//     .catch((err) => console.log(err)));
const allMapped = (managedOnly) => {
    if (allMapped.cache) return Promise.resolve(allMapped.cache);
    return axios.get(`${BASE_URL}/api/Profiles/All?managedOnly=${managedOnly}`)
        .then((r) => {
            const cache = r.data.map((i) => ({
                Value: i.Id,
                Text: i.Name,
                IdNumber: i.IdNumber,
                IsLeasingCompany: i.IsLeasingCompany,
                ForbidTransfer: i.ForbidTransfer
            }));
            allMapped.cache = cache;
            return cache;
        })
        .catch((err) => console.log(err));
};
const getCrawlerTypes = () => (axios.get(`${BASE_URL}/api/CrawlerTypes`)
    .then((r) => {
        const cache = r.data.map((i) => ({
            Value: i.Id,
            Text: i.Name,
            IdNumber: i.IdNumber,
        }));
        cache.unshift({ Value: "null", Text: "הכל" });
        return cache;
    })
    .catch((err) => console.log(err)));
const updateDocument = (profileHtmlField, html) => axios.put(`${BASE_URL}/api/Profiles/TransferHtml/${profileHtmlField}`, { Html: html });
const deleteDocument = (profileHtmlField) => axios.delete(`${BASE_URL}/api/Profiles/TransferHtml/${profileHtmlField}`);
const getDocument = (profileHtmlField) => axios.get(`${BASE_URL}/api/Profiles/TransferHtml/${profileHtmlField}`);
const setIsManaged = (isManaged) => axios.put(`${BASE_URL}/api/Profiles/Managed/${isManaged}`);
const addAutomation = () => axios.put(`${BASE_URL}/api/Profiles/Automation/Add`);
const addMileon = () => axios.put(`${BASE_URL}/api/Profiles/Mileon/Add`);
const removeMileon = () => axios.put(`${BASE_URL}/api/Profiles/Mileon/Remove`);
const addMeitar = () => axios.put(`${BASE_URL}/api/Profiles/Meitar/Add`);
const removeMeitar = () => axios.put(`${BASE_URL}/api/Profiles/Meitar/Remove`);
const allowReport = (bool) => axios.put(`${BASE_URL}/api/Profiles/AllowRePortImport/${bool}`);
const setDontShowMissingContractsTab = (bool) => axios.put(`${BASE_URL}/api/Profiles/DontShowMissingContractsTab/${bool}`);
const setIsLeasingCompany = (bool) => axios.put(`${BASE_URL}/api/Profiles/IsLeasingCompany/${bool}`);
const setAllowManualChangeMenu = (bool) => axios.put(`${BASE_URL}/api/Profiles/AllowManualChangeMenu/${bool}`);
const setUsesValidDate = (bool) => axios.put(`${BASE_URL}/api/Profiles/UsesValidDate/${bool}`);
const setAllowClientFullReportVisibility = (bool) => axios.put(`${BASE_URL}/api/Profiles/AllowClientFullReportVisibility/${bool}`);
const setIsLocatedInRePortOnline = (bool) => axios.put(`${BASE_URL}/api/Profiles/IsLocatedInRePortOnline/${bool}`);
const setStartDate = (date) => axios.put(`${BASE_URL}/api/Profiles/StartDate`, { StartDate: date });
const removeAutomation = () => axios.put(`${BASE_URL}/api/Profiles/Automation/Remove`);
const setFineCenterPassword = (password) => axios.put(`${BASE_URL}/api/Profiles/FineCenter/ChangePassword/Model`, { Password: password });
const updateProfileTracking = (id, data) => axios.put(`${BASE_URL}/api/Profiles/TrackingProviders/${id}`, data);
const getUsers = (profileId) => axios.get(`${BASE_URL}/api/Profiles/${profileId}/Users`);
const getClientAdmin = (clientId) => axios.get(`${BASE_URL}/api/Profiles/${clientId}`);
const updateClientAdmin = (clientId, data) => axios.put(`${BASE_URL}/api/Profiles/${clientId}`, data);
const updateClaims = (profileId, userId, claims) => axios.put(`${BASE_URL}/api/Profiles/${profileId}/Users/${userId}/Claims`, { Claims: claims });
const updateLastCheckDate = () => axios.put(`${BASE_URL}/api/Profiles/LastCheckDate`);
const getProfileKeys = () => axios.get(`${BASE_URL}/api/Profiles/AppKeys`);
const getProfileAppKeys = (profileId) => axios.get(`${BASE_URL}/api/Profiles/${profileId}/AppKeys`);
const getAllApps = () => axios.get(`${BASE_URL}/api/Profiles/AppKeys/Apps`);
const createProfileAppKey = (profileId, data) => axios.post(`${BASE_URL}/api/Profiles/${profileId}/AppKeys`, data);
const updateProfileAppKey = (profileId, userId, data) => axios.put(`${BASE_URL}/api/Profiles/${profileId}/AppKeys/${userId}`, data);
const deleteProfileAppKey = (profileId, userId) => axios.delete(`${BASE_URL}/api/Profiles/${profileId}/AppKeys/${userId}`);
const deleteUser = (profileId, userId) => axios.delete(`${BASE_URL}/api/Profiles/${profileId}/Users/${userId}`);
const updateIdNumber = (profileId, idNumber, setReportsToNew = false) => axios.put(`${BASE_URL}/api/Profiles/${profileId}/IdNumber`, { IdNumber: idNumber, SetReportsToNew: setReportsToNew });
const searchUsers = (search) => axios.get(`${BASE_URL}/api/Profiles/Users/Search?term=${search}`);
const attachUser = (profileId, userId) => axios.put(`${BASE_URL}/api/Profiles/${profileId}/Users/${userId}`);
const updateUserFullName = (userId, fullName) => axios.put(`${BASE_URL}/api/Profiles/Users/${userId}/FullName`, { FullName: fullName });

export default {
    get,
    update,
    users,
    all,
    updateDocument,
    getDocument,
    deleteDocument,
    getSettings,
    getMySettings,
    getMunicipalityTransferDocuments,
    upsertMunicipalityTransferDocument,
    deleteMunicipalityTransferDocument,
    getProfileAutomaticTransfer,
    addProfileAutomaticTransfer,
    deleteProfileAutomaticTransfer,
    setIsManaged,
    addAutomation,
    addMileon,
    removeMileon,
    addMeitar,
    removeMeitar,
    allowReport,
    setDontShowMissingContractsTab,
    setIsLeasingCompany,
    setAllowManualChangeMenu,
    setUsesValidDate,
    setAllowClientFullReportVisibility,
    setIsLocatedInRePortOnline,
    setStartDate,
    removeAutomation,
    setFineCenterPassword,
    updateProfileTracking,
    getUsers,
    updateClaims,
    updateLastCheckDate,
    getProfileKeys,
    getProfileAppKeys,
    getAllApps,
    createProfileAppKey,
    updateProfileAppKey,
    deleteProfileAppKey,
    deleteUser,
    usersTask,
    adminUsersTask,
    allMapped,
    getCrawlerTypes,
    addProfile,
    getClientAdmin,
    updateClientAdmin,
    updateIdNumber,
    attachUser,
    searchUsers,
    updateUserFullName,
};
